"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFontAwesome = void 0;
const fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
// import { faGaugeHigh, faIdCard, faUsers, faBars, faBell, faAngleRight } from '@fortawesome/free-solid-svg-icons'
const initFontAwesome = () => {
    // All solid icons are included in the bundle
    fontawesome_svg_core_1.library.add(free_solid_svg_icons_1.fas);
    fontawesome_svg_core_1.library.add(free_regular_svg_icons_1.faCopy);
    // Optimized, only imported icons are included in the bundle
    // library.add(faGaugeHigh, faIdCard, faUsers, faBars, faBell, faAngleRight);
};
exports.initFontAwesome = initFontAwesome;
